//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faGrid2 } from '@motionelements/assets/src/js/me-font/icons-fa6';
import {
  isProductType,
} from '@motionelements/core/src/services/catalog.service.js';

import { searchArtistElements } from '@motionelements/landing-pages/src/api/artists.js';

export default {
  name: 'ArtistProfilePageElements',
  components: {
    ProductCardAudioBackground: () => import('@motionelements/core/src/components/product-card/sections/ProductCardBackgroundAudio.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
    ElementsPreloader: () => import('@motionelements/core/src/components/product/ElementsPreloader.vue'),
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
  },
  props: {
    artist: {
      type: Object,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
    fetchOnServer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mediaType() {
      return _.get(this.element, 'mediaType', '');
    },
    isAudioLayout() {
      return isProductType('audio', this.mediaType);
    },
    facetCategories() {
      let fields = [];

      switch (true) {
        case isProductType('video', this.mediaType):
          fields = [
            'category',
            'type', // merged in category
          ];
          break;
        case isProductType('music', this.mediaType):
          fields = [
            'category',
            'genre',
            'mood',
            'instrument',
          ];
          break;
        default:
          fields = [
            'category',
          ];
      }

      const categories = fields
        .map(field => {
          const fieldCategories = _.get(this.facets, field, []);
          return fieldCategories && fieldCategories.map(category => ({
            ...category,
            fieldId: isProductType('music', this.mediaType) ? field : 'category',
          }));
        })
        .flat(1)
        .filter(category => category);

      return _.orderBy(categories, ['count'], ['desc']).slice(0, 5);
    },
  },
  data() {
    return {
      faGrid2,
      isLoading: true,
      artistElements: [],
      facets: [],
      isVisible: false,
    };
  },
  async fetch() {
    if (this.fetchOnServer) {
      this.isVisible = true;
      return this.searchArtistElements();
    }
  },
  mounted() {
    if (this.fetchOnServer) {
      this.isVisible = true;
      if (!(this.artistElements && this.artistElements.length)) {
        this.searchArtistElements();
      }
    } else {
      window.addEventListener('scroll', this.onScroll);
      this.onScroll();
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    async searchArtistElements() {
      this.isLoading = true;
      return searchArtistElements(this.mediaType, {
        contributor: this.artist.username,
        per_page: 6,
        facetarray: 1,
        page: 1,
      })
        .then((response) => {
          this.artistElements = response.data.data;
          this.facets = _.get(response.data, 'facets', {});
          const hasFreeElements = _.get(this.facets, 'priceRange', [])
            .some(({ value, count }) => value === '-1' && count > 0);
          if (hasFreeElements) {
            this.$store.dispatch('profile/addFreeMediaType', this.mediaType);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onScroll() {
      const rect = this.$refs.container.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        this.isVisible = true;
        if (!(this.artistElements && this.artistElements.length)) {
          this.searchArtistElements();
        }
        window.removeEventListener('scroll', this.onScroll); // Remove listener after loading
      }
    },
  },
};
